export default "__VITE_ASSET__e0uOpZwU__"